package org.teddapp.project.ui

import androidx.compose.foundation.layout.width

import androidx.compose.foundation.layout.Box

import androidx.compose.ui.graphics.Color

import androidx.compose.foundation.shape.RoundedCornerShape

import androidx.compose.foundation.border

import androidx.compose.foundation.layout.heightIn

import androidx.compose.foundation.layout.BoxWithConstraints

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.ColumnScope
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.widthIn
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.verticalScroll
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp

/**
 * Écran de consigne : fond uni, un sur-titre, une phrase en caractères de lecture, beaucoup
 * d'espace, puis le contenu passé (choix, champ, bouton). Pour l'auto-explication,
 * le filtre cartésien, l'exercice somatique. Plein écran sur téléphone ; sur grand écran,
 * une carte centrée au-dessus d'un voile, à la mesure de lecture.
 */
@Composable
fun TeddConsigne(
    eyebrow: String?,
    text: String,
    modifier: Modifier = Modifier,
    centered: Boolean = true,
    content: @Composable ColumnScope.() -> Unit,
) {
    BoxWithConstraints(modifier = modifier.fillMaxSize()) {
        val wide = maxWidth >= 600.dp
        val cardMaxHeight = maxHeight - 64.dp
        val shape = RoundedCornerShape(TeddTokens.RLg)
        Box(
            modifier = Modifier.fillMaxSize().background(if (wide) Color(0x66000000) else TeddTokens.Bg),
            contentAlignment = Alignment.Center,
        ) {
            Column(
                modifier = (if (wide) {
                    Modifier
                        .width(560.dp)
                        .heightIn(max = cardMaxHeight)
                        .teddOverlayShadow(shape)
                        .background(TeddTokens.SurfaceOverlay, shape)
                        .border(1.dp, TeddTokens.Line, shape)
                        .verticalScroll(rememberScrollState())
                        .padding(TeddSpace.S8)
                } else {
                    Modifier.fillMaxSize().verticalScroll(rememberScrollState()).padding(horizontal = 28.dp, vertical = 40.dp)
                }),
                horizontalAlignment = if (centered) Alignment.CenterHorizontally else Alignment.Start,
                verticalArrangement = Arrangement.Center,
            ) {
                if (eyebrow != null) {
                    Text(eyebrow.uppercase(), style = TeddType.Overline, color = TeddTokens.InkMuted)
                    Spacer(modifier = Modifier.height(TeddSpace.S3))
                }
                Text(
                    text = text,
                    style = TeddType.Quote,
                    color = TeddTokens.Ink,
                    textAlign = if (centered) TextAlign.Center else TextAlign.Start,
                    modifier = Modifier.widthIn(max = 520.dp),
                )
                Spacer(modifier = Modifier.height(TeddSpace.S6))
                Column(
                    modifier = Modifier.widthIn(max = 520.dp),
                    horizontalAlignment = if (centered) Alignment.CenterHorizontally else Alignment.Start,
                    verticalArrangement = Arrangement.spacedBy(TeddSpace.S3),
                    content = content,
                )
            }
        }
    }
}
